import Swiper, { Autoplay } from 'swiper'

import './hero-home.scss'

const selectors = {
  hero: '[data-hero]',
  heroOverlay: '[data-hero-overlay]',
  heroOverlayTrigger: '[data-hero-overlay-trigger]',

  active: 'active',
}

const initHeroHomeSwiper = () => {
  new Swiper('.hh__header-titles-swiper.swiper', {
    modules: [Autoplay],
    slidesPerView: 1,
    loop: true,
    simulateTouch: false,

    autoplay: {
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: false,
      stopOnLastSlide: false,
      pauseOnMouseEnter: false,
    },

    speed: 0,
  })
}

const initHeroHome = (hero) => {
  const overlay = hero.querySelector(selectors.heroOverlay)
  const triggers = hero.querySelectorAll(selectors.heroOverlayTrigger)

  triggers?.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      overlay.classList.toggle(selectors.active)
    })
  })
}

document.addEventListener('DOMContentLoaded', async function () {
  const hero = document.querySelector(selectors.hero)

  if (!hero) return

  initHeroHomeSwiper()
  initHeroHome(hero)
})
